import { roundTo } from '@/utils';

export const INITIAL_WIDTH = 100;

export function generateSnippet(
  width: number,
  variant: 'default' | 'fixed' | 'viewbox'
) {
  if (variant === 'default') {
    return `
<svg width="${width}" height="220">
  <circle
    cx="150"
    cy="110"
    r="60"
    stroke="var(--gold)"
    stroke-width="10"
  />
</svg>`;
  } else if (variant === 'viewbox') {
    return `
<svg
  width="${width}"
  viewBox="0 0 300 220"
>
  <circle
    cx="150"
    cy="110"
    r="60"
    stroke="var(--gold)"
    stroke-width="10"
  />
</svg>`;
  }

  const widthRatio = width / 300;
  const height = roundTo(220 * widthRatio, 1);
  const cx = roundTo(150 * widthRatio, 1);
  const cy = roundTo(110 * widthRatio, 1);
  const r = roundTo(60 * widthRatio, 1);
  const strokeWidth = roundTo(10 * widthRatio, 1);

  return `
<svg width="${width}" height="${height}">
  <circle
    cx="${cx}"
    cy="${cy}"
    r="${r}"
    stroke="var(--gold)"
    stroke-width="${strokeWidth}"
  />
</svg>`;
}
